import { useEffect, useState } from 'react'
import { trpc } from '../../../utils'
import { TableSettingsForm } from '../../organisms'
import type { PrivateTableSettingsType } from '../../organisms/CreatePrivateTable/types'
import { settingsBlock } from './index.css'

export const TableHostSettings = (props: {
  tableId: string
  playersCount: number
  onChange: (data: PrivateTableSettingsType) => void
}) => {
  const { mutate: requestTableInfo, data } = trpc.table.getTable.useMutation()
  const [privateTable, setPrivateTable] = useState<typeof data>()

  useEffect(() => {
    requestTableInfo({
      tableId: props.tableId,
      password: null,
    })
  }, [props.tableId, requestTableInfo])

  useEffect(() => {
    if (data) {
      setPrivateTable(data)
    }
  }, [data])

  useEffect(() => {
    if (!privateTable) {
      return
    }
    props.onChange(privateTable)
  }, [privateTable])

  const onFieldChange = <GKey extends keyof PrivateTableSettingsType>(
    field: GKey,
    value: PrivateTableSettingsType[GKey],
  ) => {
    // @ts-expect-error typeof data sucks
    setPrivateTable((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  if (!privateTable) {
    return null
  }

  return (
    <div className={settingsBlock}>
      <TableSettingsForm
        settings={privateTable}
        mode='update'
        limits={{
          maxPlayers: {
            min: props.playersCount,
          },
        }}
        onChange={onFieldChange}
      />
    </div>
  )
}
